$(document).on('click', '.new_featured_collection .collection_inner .single_tab', function(){
    var collectionHandle = $(this).attr('collection_handle');
    $('.new_featured_collection .collection_inner .single_tab').removeClass('active');
    $(this).addClass('active');
    $('.new_featured_collection .collection_inner .collections_list .only_collection').addClass('hidden');
    $('.new_featured_collection .collection_inner .collections_list .only_collection[collection_handle="'+ collectionHandle +'"]').removeClass('hidden');
    $(".new_featured_collection .collections_list .only_collection .single_collection").slick('refresh');
  });

  // CWI AJ
if($(".new_featured_collection .collections_list .single_collection").length){
    $(".new_featured_collection .collections_list .single_collection").each(function( index ){
      var e = $(this);
      e.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        prevArrow: e.parents('.only_collection').find(".slick__prev"),
        nextArrow: e.parents('.only_collection').find(".slick__next"),
        responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    });  
  }
